var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_67343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.89258 1.27228C6.62468 1.1306 7.37715 1.1306 8.10924 1.27228",
    stroke: "#616E85",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10924 12.7266C7.37715 12.8682 6.62468 12.8682 5.89258 12.7266",
    stroke: "#616E85",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2715 2.16992C10.8907 2.58947 11.4234 3.12418 11.8407 3.74492",
    stroke: "#616E85",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27228 8.10924C1.1306 7.37715 1.1306 6.62468 1.27228 5.89258",
    stroke: "#616E85",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8289 10.2715C11.4094 10.8907 10.8746 11.4234 10.2539 11.8407",
    stroke: "#616E85",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7266 5.89258C12.8682 6.62468 12.8682 7.37715 12.7266 8.10924",
    stroke: "#616E85",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.16992 3.72932C2.58947 3.11013 3.12418 2.5774 3.74492 2.16016",
    stroke: "#616E85",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72932 11.8289C3.11013 11.4094 2.5774 10.8746 2.16016 10.2539",
    stroke: "#616E85",
    strokeWidth: 1.09375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_67343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateStatus);
export default __webpack_public_path__ + "static/media/UpdateStatus.e6322c5c8f76d06e0dd6a7cdca363ef2.svg";
export { ForwardRef as ReactComponent };